// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2uonH","label":"CategoryService_label__3BK66","location":"CategoryService_location__336LJ"};